import { deleteApiDependent } from "./deleteApiDependent";
import { getApiDependent } from "./getApiDependent";
import { getApiDependentGetAll } from "./getApiDependentGetAll";
import { postApiDependent } from "./postApiDependent";
import { putApiDependent } from "./putApiDependent";

export function dependentController() {
  return {
    postApiDependent,
    getApiDependent,
    deleteApiDependent,
    putApiDependent,
    getApiDependentGetAll,
  };
}
